import { createSelector } from '@ngrx/store';

import { getCurrentRoute } from '../getCurrentRoute';

export const isCurrentRouteEmailConfirmationPage = createSelector(getCurrentRoute, (current) => current?.url?.startsWith('/email-confirmation') || false);
